<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile class="remove-print">
        <v-card-title>Pelunasan Tagihan External</v-card-title>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row align="center">
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-select
                  label="Filter POS"
                  dense
                  hide-details
                  :items="posOptions"
                  v-model="selectedPos"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-select
                  label="Filter Nama Penagih"
                  dense
                  hide-details
                  :items="penagihOptions"
                  v-model="selectedPenagih"
                ></v-select>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-text-field
                  label="Tgl Transfer *"
                  dense
                  hide-details
                  type="date"
                  v-model="batchForm.tgl_lunas"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-select
                  label="Posisi Pelunasan *"
                  dense
                  hide-details
                  :items="posisiOptions"
                  v-model="batchForm.posisi_pelunasan"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Keterangan Pelunasan"
                  dense
                  hide-details
                  v-model="batchForm.keterangan_pelunasan"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content d-flex align-center">
                <v-btn
                  color="primary"
                  :loading="loading.saveBatch"
                  :disabled="!canLunaskanBatch"
                  @click="lunaskanBatch"
                  small
                  class="mr-2"
                >
                  <v-icon left small>mdi-checkbox-multiple-marked</v-icon>
                  Lunaskan Terpilih ({{ selectedItems.length }})
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="selectedItems.length === 0" dense>
              <v-col cols="12">
                <span class="grey--text text-caption">
                  Centang minimal 1 tagihan di tabel bawah, lalu isi Tgl Transfer dan Posisi Pelunasan untuk mengaktifkan tombol.
                </span>
              </v-col>
            </v-row>
            <v-row v-if="selectedItems.length > 0" dense>
              <v-col cols="12">
                <v-alert dense text type="info" class="mb-0">
                  <strong>{{ selectedItems.length }}</strong> tagihan terpilih —
                  Total Nominal:
                  <strong>Rp {{ formatCurrency(totalSelectedNilai) }}</strong>
                  — Tgl Transfer: <strong>{{ batchForm.tgl_lunas || "belum diisi" }}</strong>
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <section v-if="receipt" class="mt-4">
        <div class="d-flex align-center flex-wrap mb-2 remove-print">
          <strong>Rincian pelunasan {{ receipt.no_pelunasan }}</strong>
          <v-spacer></v-spacer>
          <v-btn small color="primary" :loading="loading.receipt" @click="printReceipt">
            <v-icon left small>mdi-printer</v-icon>Cetak / Simpan PDF
          </v-btn>
          <v-btn small text class="ml-2" :disabled="loading.receipt" @click="receipt = null">Tutup</v-btn>
          <div class="receipt-hint mt-2">Untuk menyimpan PDF, pilih tujuan “Save as PDF” / “Simpan sebagai PDF” pada dialog cetak.</div>
        </div>
        <main id="section-print" class="payment-report">
          <h2>RINCIAN PELUNASAN TAGIHAN EXTERNAL</h2>
          <p class="report-number">{{ receipt.no_pelunasan }}</p>
          <dl class="report-meta">
            <dt>Tanggal Transfer / Bayar</dt><dd>{{ formatDate(receipt.tgl_lunas) }}</dd>
            <dt>Posisi Pelunasan</dt><dd>{{ receipt.posisi_pelunasan }}</dd>
            <dt>Keterangan Pelunasan</dt><dd>{{ receipt.keterangan_pelunasan || "-" }}</dd>
            <dt>Jumlah Tagihan</dt><dd>{{ receipt.jumlah_tagihan }}</dd>
          </dl>
          <p v-if="hasInactiveReceiptItems" class="report-warning">
            Ada pelunasan yang dibatalkan atau tidak lagi aktif pada laporan ini. Rincian dan total di bawah adalah catatan saat pelunasan disimpan; lihat status setiap tagihan.
          </p>
          <div class="report-table-wrapper">
            <table class="report-table">
              <thead>
                <tr>
                  <th>No.</th><th>No. / Tgl Tagihan</th><th>Nama Penagih / Rekening</th>
                  <th>Kategori / POS</th><th>Keterangan Tagihan</th><th>Nominal (Rp)</th><th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in receipt.rincian" :key="item.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.no_tagihan }}<br>{{ formatDate(item.tgl_tagihan) }}</td>
                  <td>{{ item.nama_penagih || "-" }}<br>{{ item.no_rekening || "-" }}</td>
                  <td>{{ item.kategori_tagihan || "-" }}<br>{{ item.pos || "-" }}</td>
                  <td class="report-description">{{ item.keterangan_tagihan || "-" }}</td>
                  <td class="report-amount">{{ formatCurrency(item.nilai_tagihan) }}</td>
                  <td>{{ item.aktif ? "Lunas" : "Tidak aktif / dibatalkan" }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="5" class="report-total-label">Total Pelunasan ({{ receipt.jumlah_tagihan }} tagihan)</th>
                  <th class="report-amount">{{ formatCurrency(receipt.total) }}</th><th></th>
                </tr>
              </tfoot>
            </table>
          </div>
          <p class="report-note">Rincian berdasarkan data saat pelunasan dicatat dalam sistem.</p>
        </main>
      </section>

      <v-data-table
        :headers="dataHeaders"
        :items="filteredData"
        :loading="loading.fetchData"
        :items-per-page="10"
        :sort-by="['tgl_jatuh_tempo']"
        :sort-desc="[false]"
        class="elevation-1 mt-2 scrollbar-top remove-print"
        dense
        item-key="id"
      >
        <template v-slot:top>
          <v-toolbar flat dense>
            <v-toolbar-title style="font-size: 14px; font-weight: 600;">
              Daftar Tagihan External
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Cari tagihan..."
              single-line
              hide-details
              dense
              style="max-width: 250px;"
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:header.select="{ }">
          <v-simple-checkbox
            :value="isAllSelected"
            :indeterminate="isSomeSelected && !isAllSelected"
            @input="toggleSelectAll"
            :disabled="filteredData.length === 0"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.select="{ item }">
          <v-simple-checkbox
            :value="isSelected(item.id)"
            @input="toggleSelect(item.id)"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.tgl_tagihan="{ item }">
          {{ formatDate(item.tgl_tagihan) }}
        </template>
        <template v-slot:item.nilai_tagihan="{ item }">
          <span class="font-weight-bold">{{ formatCurrency(item.nilai_tagihan) }}</span>
        </template>
        <template v-slot:item.tgl_jatuh_tempo="{ item }">
          <span :class="isOverdue(item.tgl_jatuh_tempo) ? 'red--text font-weight-bold' : ''">
            {{ item.tgl_jatuh_tempo || "-" }}
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex align-center flex-nowrap">
            <v-btn
              x-small
              outlined
              icon
              color="primary"
              class="mr-2"
              title="Edit Nominal"
              :disabled="loading.saveEdit || loading.saveData || loading.saveBatch"
              @click="editItem(item)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              x-small
              color="success"
              :disabled="loading.saveEdit"
              @click="selectItem(item)"
            >
              Lunaskan
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <v-card tile class="mt-4 remove-print">
        <v-card-title class="text-h6">
          Riwayat Pelunasan Gabungan
          <v-spacer></v-spacer>
          <v-btn small text :loading="loading.history" @click="fetchHistory">Muat Ulang</v-btn>
        </v-card-title>
        <v-card-text>
          <p>Rincian pembayaran gabungan yang dicatat sejak fitur ini tersedia dapat dibuka dan dicetak ulang di sini.</p>
          <v-alert v-if="historyError" dense text type="error">{{ historyError }}</v-alert>
          <v-simple-table dense>
            <thead><tr><th>No. Pelunasan</th><th>Tgl Transfer / Bayar</th><th>Posisi</th><th>Keterangan</th><th>Jumlah Tagihan</th><th>Total (Rp)</th><th></th></tr></thead>
            <tbody>
              <tr v-for="item in history" :key="item.id">
                <td>{{ item.no_pelunasan }}</td><td>{{ formatDate(item.tgl_lunas) }}</td>
                <td>{{ item.posisi_pelunasan }}</td><td>{{ item.keterangan_pelunasan || "-" }}</td>
                <td>{{ item.jumlah_tagihan }}</td><td>{{ formatCurrency(item.total) }}</td>
                <td class="text-no-wrap">
                  <v-btn small text color="primary" :disabled="loading.receipt" @click="openReceipt(item.id)">Lihat / Cetak</v-btn>
                  <v-btn small text color="orange darken-2" :disabled="loading.receipt || loading.saveHistoryEdit" @click="editHistory(item)">Edit</v-btn>
                </td>
              </tr>
              <tr v-if="!history.length"><td colspan="7">{{ loading.history ? "Memuat riwayat..." : "Belum ada riwayat pelunasan gabungan." }}</td></tr>
            </tbody>
          </v-simple-table>
          <v-pagination v-if="historyPages > 1" v-model="historyPage" :length="historyPages" :disabled="loading.history" @input="fetchHistory"></v-pagination>
        </v-card-text>
      </v-card>

      <v-dialog v-model="dialogEditHistory" max-width="500px" :persistent="loading.saveHistoryEdit">
        <v-card>
          <v-card-title class="text-h6 font-weight-bold">Edit Pelunasan {{ historyForm.no_pelunasan }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-alert dense text type="info" class="mb-4">
              Perubahan berlaku untuk semua tagihan yang masih lunas di pelunasan ini.
            </v-alert>
            <v-text-field
              label="Tgl Transfer / Bayar *"
              dense
              type="date"
              v-model="historyForm.tgl_lunas"
              :disabled="loading.saveHistoryEdit"
            ></v-text-field>
            <v-select
              label="Posisi Pelunasan *"
              dense
              :items="posisiOptions"
              v-model="historyForm.posisi_pelunasan"
              :disabled="loading.saveHistoryEdit"
            ></v-select>
            <v-text-field
              label="Keterangan Pelunasan"
              dense
              v-model="historyForm.keterangan_pelunasan"
              :disabled="loading.saveHistoryEdit"
              @keyup.enter="submitHistoryEdit"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="pb-4 px-4">
            <v-spacer></v-spacer>
            <v-btn text :disabled="loading.saveHistoryEdit" @click="dialogEditHistory = false">Batal</v-btn>
            <v-btn
              color="primary"
              :loading="loading.saveHistoryEdit"
              :disabled="loading.saveHistoryEdit || !/^\d{4}-\d{2}-\d{2}$/.test(historyForm.tgl_lunas || '') || !historyForm.posisi_pelunasan"
              @click="submitHistoryEdit"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEdit" max-width="500px" :persistent="loading.saveEdit">
        <v-card>
          <v-card-title class="text-h6 font-weight-bold">Edit Nominal Tagihan</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <div class="mb-2">No Tagihan: <strong>{{ editFormData.no_tagihan || "-" }}</strong></div>
            <div class="mb-4">Nama Penagih: <strong>{{ editFormData.nama_penagih || "-" }}</strong></div>
            <v-form ref="editForm" @submit.prevent="submitEdit">
              <v-text-field
                label="Nilai Tagihan *"
                type="number"
                min="0"
                step="any"
                prefix="Rp"
                autofocus
                v-model="editFormData.nilai_tagihan"
                :rules="nilaiTagihanRules"
                :disabled="loading.saveEdit"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-4 px-4">
            <v-spacer></v-spacer>
            <v-btn text @click="dialogEdit = false" :disabled="loading.saveEdit">Batal</v-btn>
            <v-btn color="primary" :loading="loading.saveEdit" :disabled="loading.saveEdit" @click="submitEdit">
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Pelunasan Modal (per-item) -->
      <v-dialog v-model="dialogPelunasan" max-width="500px">
        <v-card>
          <v-card-title class="text-h6 font-weight-bold">
            Pelunasan Tagihan External
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-simple-table dense class="mb-4">
              <tbody>
                <tr>
                  <td class="font-weight-bold" style="width: 140px;">No Tagihan</td>
                  <td>{{ dialogData.no_tagihan || "-" }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Nama Penagih</td>
                  <td>{{ dialogData.nama_penagih || "-" }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Nilai Tagihan</td>
                  <td class="font-weight-bold primary--text">
                    Rp {{ formatCurrency(dialogData.nilai_tagihan) }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-text-field
              label="Tanggal Lunas *"
              dense
              type="date"
              v-model="dialogData.tgl_lunas"
              :rules="[v => !!v || 'Tanggal lunas harus diisi']"
              :hint="dialogData.tgl_lunas ? formatDateReadable(dialogData.tgl_lunas) : ''"
              persistent-hint
            ></v-text-field>

            <v-select
              label="Posisi Pelunasan *"
              dense
              :items="posisiOptions"
              v-model="dialogData.posisi_pelunasan"
              :rules="[v => !!v || 'Posisi pelunasan harus dipilih']"
            ></v-select>

            <v-text-field
              label="Keterangan Pelunasan"
              dense
              v-model="dialogData.keterangan_pelunasan"
              placeholder="Contoh: Dibayar via transfer BCA"
              @keyup.enter="submitDialogPelunasan"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="pb-4 px-4">
            <v-spacer></v-spacer>
            <v-btn text @click="dialogPelunasan = false" :disabled="loading.saveData">
              Batal
            </v-btn>
            <v-btn
              color="primary"
              :loading="loading.saveData"
              :disabled="loading.saveData || !dialogData.tgl_lunas || !dialogData.posisi_pelunasan"
              @click="submitDialogPelunasan"
            >
              Lunaskan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Konfirmasi batch. Pakai v-dialog, bukan window.confirm(), karena
           browser bisa memblokir confirm/alert berikutnya ("cegah dialog
           tambahan") sehingga tombol terlihat tidak bereaksi. -->
      <v-dialog v-model="confirmBatch" max-width="460px" persistent>
        <v-card>
          <v-card-title class="text-h6 font-weight-bold">
            Lunaskan {{ selectedItems.length }} tagihan?
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-simple-table dense>
              <tbody>
                <tr>
                  <td class="font-weight-bold" style="width: 150px;">Tgl Transfer</td>
                  <td>{{ formatDateReadable(batchForm.tgl_lunas) }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Posisi Pelunasan</td>
                  <td>{{ batchForm.posisi_pelunasan }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Total</td>
                  <td class="font-weight-bold primary--text">
                    Rp {{ formatCurrency(totalSelectedNilai) }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="pb-4 px-4">
            <v-spacer></v-spacer>
            <v-btn text :disabled="loading.saveBatch" @click="confirmBatch = false">
              Batal
            </v-btn>
            <v-btn color="primary" :loading="loading.saveBatch" @click="submitBatch">
              Ya, Lunaskan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="4000" top>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">Tutup</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { formatDateOnly } from "@/util/helpers";

const today = () =>
  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substr(0, 10);

export default {
  name: "PelunasanTagihanExternal",
  data() {
    return {
      loading: {
        saveData: false,
        saveBatch: false,
        saveEdit: false,
        saveHistoryEdit: false,
        fetchData: false,
        history: false,
        receipt: false
      },
      receipt: null,
      history: [],
      historyPage: 1,
      historyPages: 1,
      historyError: "",
      search: "",
      selectedPos: "SEMUA",
      selectedPenagih: "SEMUA",
      // NOTE: selectedPos/selectedPenagih/search all narrow filteredData;
      // watchers below prune selectedItems so a batch pelunasan can never
      // silently include a tagihan the user can no longer see on screen.
      posisiOptions: ["Kas Utama", "Kas Kecil", "Transfer"],
      // Batch form
      batchForm: {
        tgl_lunas: today(),
        posisi_pelunasan: "Kas Utama",
        keterangan_pelunasan: ""
      },
      selectedItems: [],
      confirmBatch: false,
      snackbar: { show: false, text: "", color: "success" },
      dialogEditHistory: false,
      historyForm: {
        id: null,
        no_pelunasan: "",
        tgl_lunas: "",
        posisi_pelunasan: "",
        keterangan_pelunasan: ""
      },
      dialogEdit: false,
      editFormData: {},
      nilaiTagihanRules: [
        value => (value !== null && value !== undefined && String(value).trim() !== "") || "Nilai tagihan harus diisi",
        value => (Number.isFinite(Number(value)) && Number(value) >= 0) || "Nilai tagihan harus berupa angka minimal 0"
      ],
      // Per-item dialog
      dialogPelunasan: false,
      dialogData: {
        id: null,
        no_tagihan: "",
        nama_penagih: "",
        nilai_tagihan: 0,
        tgl_lunas: today(),
        posisi_pelunasan: "Kas Utama",
        keterangan_pelunasan: ""
      },
      dataHeaders: [
        { text: "", value: "select", sortable: false, width: "50px" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "Kategori", value: "kategori_tagihan" },
        { text: "Tgl Tagihan", value: "tgl_tagihan" },
        { text: "No Tagihan", value: "no_tagihan" },
        { text: "Keterangan", value: "keterangan_tagihan" },
        { text: "Nilai Tagihan", value: "nilai_tagihan", align: "end" },
        { text: "Jatuh Tempo", value: "tgl_jatuh_tempo" },
        { text: "POS", value: "pos" },
        { text: "Nama Penagih", value: "nama_penagih" }
      ],
      data: []
    };
  },
  computed: {
    hasInactiveReceiptItems() {
      return this.receipt && this.receipt.rincian.some(item => !item.aktif);
    },
    posOptions() {
      const positions = this.data
        .map(item => item.pos)
        .filter(Boolean)
        .filter((pos, index, items) => items.indexOf(pos) === index)
        .sort();

      return [
        { text: "Keseluruhan", value: "SEMUA" },
        ...positions.map(pos => ({ text: pos, value: pos }))
      ];
    },
    penagihOptions() {
      const names = this.data
        .map(item => item.nama_penagih)
        .filter(Boolean)
        .filter((name, index, items) => items.indexOf(name) === index)
        .sort((a, b) => a.localeCompare(b));

      return [
        { text: "Keseluruhan", value: "SEMUA" },
        ...names.map(name => ({ text: name, value: name }))
      ];
    },
    filteredData() {
      const term = (this.search || "").trim().toLowerCase();

      return this.data.filter(item => {
        const posMatch =
          this.selectedPos === "SEMUA" || item.pos === this.selectedPos;
        const penagihMatch =
          this.selectedPenagih === "SEMUA" ||
          item.nama_penagih === this.selectedPenagih;
        const searchMatch =
          !term ||
          Object.values(item).some(
            val => val && String(val).toLowerCase().includes(term)
          );

        return posMatch && penagihMatch && searchMatch;
      });
    },
    isAllSelected() {
      return (
        this.filteredData.length > 0 &&
        this.filteredData.every(item => this.selectedItems.includes(item.id))
      );
    },
    isSomeSelected() {
      return (
        this.selectedItems.length > 0 && !this.isAllSelected
      );
    },
    totalSelectedNilai() {
      // Sum across the full dataset (not just filteredData) so the total
      // stays accurate even if some selected items are hidden by the
      // current POS/Penagih/search filter.
      return this.data
        .filter(item => this.selectedItems.includes(item.id))
        .reduce((sum, item) => sum + Number(item.nilai_tagihan || 0), 0);
    },
    isValidDate() {
      return /^\d{4}-\d{2}-\d{2}$/.test(this.batchForm.tgl_lunas || "");
    },
    canLunaskanBatch() {
      return (
        !this.loading.saveEdit &&
        !this.loading.saveBatch &&
        this.selectedItems.length > 0 &&
        this.isValidDate &&
        !!this.batchForm.posisi_pelunasan
      );
    }
  },
  watch: {
    // Prevent a hidden tagihan from staying "selected" once it's filtered
    // out of view — avoids batch-lunaskan touching a row the user can't see.
    selectedPos() {
      this.pruneHiddenSelections();
    },
    selectedPenagih() {
      this.pruneHiddenSelections();
    },
    search() {
      this.pruneHiddenSelections();
    }
  },
  methods: {
    async fetchHistory() {
      if (this.loading.history) return;
      this.loading.history = true;
      this.historyError = "";
      try {
        const res = await axios.get("tagihan-external/pelunasan-batch", { params: { page: this.historyPage } });
        this.history = res.data.data;
        this.historyPages = res.data.last_page;
      } catch (err) {
        this.historyError = err.response?.data?.message || "Gagal memuat riwayat pelunasan. Silakan muat ulang.";
      } finally {
        this.loading.history = false;
      }
    },
    editHistory(item) {
      this.historyForm = {
        id: item.id,
        no_pelunasan: item.no_pelunasan,
        tgl_lunas: (item.tgl_lunas || "").substr(0, 10),
        posisi_pelunasan: item.posisi_pelunasan,
        keterangan_pelunasan: item.keterangan_pelunasan || ""
      };
      this.dialogEditHistory = true;
    },
    async submitHistoryEdit() {
      if (this.loading.saveHistoryEdit || !this.historyForm.id) return;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(this.historyForm.tgl_lunas || "") || !this.historyForm.posisi_pelunasan) {
        this.notify("Tanggal dan posisi pelunasan harus diisi", "warning");
        return;
      }
      this.loading.saveHistoryEdit = true;
      try {
        const res = await axios.put(`tagihan-external/pelunasan-batch/${this.historyForm.id}`, {
          tgl_lunas: this.historyForm.tgl_lunas,
          posisi_pelunasan: this.historyForm.posisi_pelunasan,
          keterangan_pelunasan: this.historyForm.keterangan_pelunasan
        });
        this.dialogEditHistory = false;
        if (this.receipt && this.receipt.id === this.historyForm.id) this.receipt = res.data.pelunasan;
        await this.fetchHistory();
        this.notify(res.data?.message || "Pelunasan berhasil diperbarui");
      } catch (err) {
        this.notify(err.response?.data?.message || "Gagal memperbarui pelunasan", "error");
      } finally {
        this.loading.saveHistoryEdit = false;
      }
    },
    async openReceipt(id) {
      this.loading.receipt = true;
      try {
        const res = await axios.get(`tagihan-external/pelunasan-batch/${id}`);
        this.receipt = res.data;
        await this.$nextTick();
        document.getElementById("section-print").scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      } catch (err) {
        this.notify(err.response?.data?.message || "Gagal memuat rincian pelunasan", "error");
        return false;
      } finally {
        this.loading.receipt = false;
      }
    },
    async printReceipt() {
      // Refresh status so a cancelled bill is never printed as still paid.
      if (!this.receipt || this.loading.receipt) return;
      if (await this.openReceipt(this.receipt.id)) {
        await this.$nextTick();
        window.print();
      }
    },
    notify(text, color = "success") {
      this.snackbar = { show: true, text, color };
    },
    editItem(item) {
      this.editFormData = { ...item };
      this.dialogEdit = true;
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.resetValidation();
      });
    },
    async submitEdit() {
      if (this.loading.saveEdit || !this.editFormData.id) return;
      if (!this.nilaiTagihanRules.every(rule => rule(this.editFormData.nilai_tagihan) === true)) {
        if (this.$refs.editForm) this.$refs.editForm.validate();
        return;
      }

      const item = this.editFormData;
      const nilaiTagihan = Number(item.nilai_tagihan);
      this.loading.saveEdit = true;

      try {
        const res = await axios.put(`tagihan-external/${item.id}`, {
          pos: item.pos,
          kategori_tagihan: item.kategori_tagihan,
          nama_penagih: item.nama_penagih,
          no_rekening: item.no_rekening,
          tgl_tagihan: item.tgl_tagihan,
          no_tagihan: item.no_tagihan,
          keterangan_tagihan: item.keterangan_tagihan,
          nilai_tagihan: nilaiTagihan,
          tgl_jatuh_tempo: item.tgl_jatuh_tempo,
          kv: item.kv
        });
        this.data = this.data.map(row =>
          row.id === item.id ? { ...row, nilai_tagihan: nilaiTagihan } : row
        );
        this.pruneHiddenSelections();
        this.dialogEdit = false;
        this.notify(res.data?.message || "Nominal tagihan berhasil diperbarui");
      } catch (err) {
        this.notify(err.response?.data?.message || "Gagal menyimpan nominal tagihan", "error");
      } finally {
        this.loading.saveEdit = false;
      }
    },
    pruneHiddenSelections() {
      const visibleIds = this.filteredData.map(item => item.id);
      this.selectedItems = this.selectedItems.filter(id =>
        visibleIds.includes(id)
      );
    },
    formatCurrency(val) {
      if (!val) return "0";
      return Number(val).toLocaleString("id-ID");
    },
    formatDate(date) {
      return formatDateOnly(date);
    },
    formatDateReadable(dateStr) {
      if (!dateStr) return "-";
      const [year, month, day] = dateStr.split("-").map(Number);
      if (!year || !month || !day) return dateStr;

      const bulan = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
      ];

      return `${day} ${bulan[month - 1]} ${year}`;
    },
    isOverdue(dateStr) {
      if (!dateStr) return false;
      return new Date(dateStr) < new Date(new Date().toDateString());
    },
    // Selection methods
    isSelected(id) {
      return this.selectedItems.includes(id);
    },
    toggleSelect(id) {
      const idx = this.selectedItems.indexOf(id);
      if (idx > -1) {
        this.selectedItems.splice(idx, 1);
      } else {
        this.selectedItems.push(id);
      }
    },
    toggleSelectAll(val) {
      if (val) {
        this.selectedItems = this.filteredData.map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    // Data fetching — only load unpaid items
    async fetchData() {
      this.loading.fetchData = true;

      await axios
        .get(`tagihan-external/belum-lunas`)
        .then(res => {
          this.data = res.data;
          this.loading.fetchData = false;
          // Remove selected items that no longer exist in the list
          const currentIds = this.data.map(item => item.id);
          this.selectedItems = this.selectedItems.filter(id =>
            currentIds.includes(id)
          );
        })
        .catch(err => {
          this.loading.fetchData = false;
          this.notify(err.response?.data?.message || "Gagal memuat data tagihan", "error");
        });
    },
    // Batch pelunasan
    lunaskanBatch() {
      if (this.selectedItems.length === 0) {
        this.notify("Pilih minimal 1 tagihan untuk dilunaskan", "warning");
        return;
      }
      if (!this.isValidDate) {
        this.notify("Tanggal transfer belum valid. Silakan pilih ulang tanggalnya lewat kalender.", "warning");
        return;
      }
      if (!this.batchForm.posisi_pelunasan) {
        this.notify("Posisi pelunasan harus dipilih", "warning");
        return;
      }
      this.confirmBatch = true;
    },
    async submitBatch() {
      if (this.loading.saveBatch) return;
      this.loading.saveBatch = true;

      await axios
        .put(`tagihan-external/pelunasan-batch`, {
          ids: this.selectedItems,
          tgl_lunas: this.batchForm.tgl_lunas,
          posisi_pelunasan: this.batchForm.posisi_pelunasan,
          keterangan_pelunasan: this.batchForm.keterangan_pelunasan
        })
        .then(res => {
          this.loading.saveBatch = false;
          this.confirmBatch = false;
          this.receipt = res.data.pelunasan;
          this.selectedItems = [];
          this.batchForm.keterangan_pelunasan = "";
          this.fetchData();
          this.historyPage = 1;
          this.fetchHistory();
          this.$nextTick(() => {
            document.getElementById("section-print").scrollIntoView({ behavior: "smooth", block: "start" });
          });
          this.notify(res.data.message);
        })
        .catch(err => {
          this.loading.saveBatch = false;
          this.confirmBatch = false;
          this.notify(
            err.response?.data?.message || "Gagal melunaskan tagihan batch",
            "error"
          );
          if (err.response?.status === 409) this.fetchData();
        });
    },
    // Per-item dialog pelunasan
    selectItem(item) {
      this.dialogData = {
        id: item.id,
        no_tagihan: item.no_tagihan,
        nama_penagih: item.nama_penagih,
        nilai_tagihan: item.nilai_tagihan,
        tgl_lunas: item.tgl_lunas || today(),
        posisi_pelunasan: item.posisi_pelunasan || "Kas Utama",
        keterangan_pelunasan: item.keterangan_pelunasan || ""
      };
      this.dialogPelunasan = true;
    },
    async submitDialogPelunasan() {
      if (!this.dialogData.id || !this.dialogData.tgl_lunas) {
        this.notify("Pilih tagihan dan isi tanggal lunas", "warning");
        return;
      }
      if (!this.dialogData.posisi_pelunasan) {
        this.notify("Pilih posisi pelunasan (Kas Utama, Kas Kecil, atau Transfer)", "warning");
        return;
      }

      this.loading.saveData = true;

      await axios
        .put(`tagihan-external/pelunasan/${this.dialogData.id}`, {
          tgl_lunas: this.dialogData.tgl_lunas,
          posisi_pelunasan: this.dialogData.posisi_pelunasan,
          keterangan_pelunasan: this.dialogData.keterangan_pelunasan
        })
        .then(res => {
          this.loading.saveData = false;
          this.dialogPelunasan = false;
          this.fetchData();
          this.notify(res.data?.message || "Tagihan berhasil dilunaskan");
        })
        .catch(err => {
          this.loading.saveData = false;
          this.notify(err.response?.data?.message || "Gagal melunaskan tagihan", "error");
        });
    },

  },
  created() {
    this.fetchData();
    this.fetchHistory();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}

.receipt-hint { width: 100%; font-size: 12px; }
.payment-report { background: white; color: #111; padding: 24px; font-family: Arial, sans-serif; }
.payment-report h2 { text-align: center; font-size: 18px; }
.report-number { text-align: center; margin: 4px 0 20px; }
.report-meta { display: grid; grid-template-columns: 180px 1fr; gap: 4px 12px; margin-bottom: 20px; font-size: 13px; }
.report-meta dt { font-weight: bold; }
.report-meta dd { margin: 0; white-space: pre-wrap; overflow-wrap: anywhere; }
.report-table-wrapper { overflow-x: auto; }
.report-table { border-collapse: collapse; width: 100%; font-size: 12px; }
.report-table th, .report-table td { border: 1px solid #777; padding: 7px; vertical-align: top; overflow-wrap: anywhere; }
.report-table th { font-weight: bold !important; }
.report-description { white-space: pre-wrap; }
.report-amount { text-align: right; white-space: nowrap; }
.report-total-label { text-align: right; }
.report-note { margin-top: 12px; font-size: 11px; }
.report-warning { border: 1px solid #777; padding: 8px; font-size: 12px; }

@media print {
  @page pelunasanExternal { size: A4 landscape; margin: 12mm; }
  .remove-print { display: none !important; }
  #section-print.payment-report { page: pelunasanExternal; padding: 0; margin: 0; width: 100%; }
  .report-table-wrapper { overflow: visible; }
  .report-table { table-layout: fixed; font-size: 10px; }
  .report-table th:first-child { width: 5%; }
  .report-table th:nth-child(6) { width: 14%; }
  .report-table thead { display: table-header-group; }
  .report-table tfoot { display: table-row-group; }
  .report-table tr { break-inside: avoid; }
  .report-amount { white-space: normal; }
}

/* Flip the table's scroll wrapper so the horizontal scrollbar appears on top */
.scrollbar-top >>> .v-data-table__wrapper {
  transform: rotateX(180deg);
}

/* Flip the actual table back so content displays normally */
.scrollbar-top >>> .v-data-table__wrapper > table {
  transform: rotateX(180deg);
}
</style>
